import { Injectable } from '@angular/core';
import { defer, from, lastValueFrom, Observable } from 'rxjs';
import { WebService } from '@services';

@Injectable({ providedIn: 'root' })
export class PurchaseOrderLookupsService {
  private cache = new Map<string, { value: any; expires: number }>();
  private pending = new Map<string, Promise<any>>();
  constructor(private web: WebService) {}

  get(section: string, path: string): Observable<any> {
    return defer(() => from(this.load(section, path)));
  }
  private async load(section: string, path: string): Promise<any> {
    const key = section + '/' + path;
    const cached = this.cache.get(key);
    if (cached && cached.expires > Date.now()) return structuredClone(cached.value);
    let request = this.pending.get(key);
    if (!request) {
      request = lastValueFrom(this.web.getWebCall(section, path)).then(value => {
        // Market data is shared only while in flight; stable lookups live for one minute.
        if (!path.includes('futures') && !path.includes('price-basis')) {
          this.cache.set(key, { value, expires: Date.now() + 60_000 });
        }
        return value;
      }).finally(() => this.pending.delete(key));
      this.pending.set(key, request);
    }
    return structuredClone(await request);
  }
}
